$(document).on('click', '.modal-close, .modal-additional-close', function () {
  $(this).closest('.modal').removeClass('is-active');
  $('html').removeClass('is-clipped');
});
$(document).on('turbolinks:load', function () {
  $('html').removeClass('is-clipped');
});
